import type { ModuleManifest } from '../types.js'

/**
 * Вэбсайт MPG — Majestic Prestige Global-ийн сайт `web.mpg.mn`-ийн CMS.
 *
 * ! `website` модулийн ҮГ ҮСГИЙН ХУУЛБАР (docs/mgp-website.md): өөрийн
 * ! хүснэгт (`mgp_website_*`), эрх (`mgp-website.*`), API (`/api/mgp-website/*`).
 * ! Медиа (`/api/website/media`) ХУВААЛЦСАН. Нэг талд өөрчлөлт оруулбал
 * ! нөгөөд нь давхар оруул.
 *
 * ! НИЙТИЙН API НЬ ЭНЭ МОДУЛИЙН СЭЛГҮҮРТ ЗАХИРАГДАХГҮЙ — эх модулийнх шиг
 * ! `/api/mgp-website/v1/*` нь `@Public()`; сайтыг хаах газар нь Сайтын
 * ! тохиргоон дахь «Нийтэлсэн» сэлгүүр.
 */
export const mgpWebsiteModule = {
  key: 'mgp-website',
  name: 'Веб сайт MPG',
  description: 'MPG-ийн сайтын (web.mpg.mn) хуудас, меню, мэдээ, холбоо барих хүсэлт.',
  version: '1.0.0',
  icon: 'GlobeIcon',

  permissions: [
    { resource: 'mgp-website.pages', action: 'list', description: 'Сайтын хуудсууд харах' },
    { resource: 'mgp-website.pages', action: 'show', description: 'Хуудасны блокууд харах' },
    { resource: 'mgp-website.pages', action: 'manage', description: 'Хуудас, блок үүсгэх, засах, устгах' },

    { resource: 'mgp-website.menu', action: 'manage', description: 'Сайтын цэс удирдах' },
    { resource: 'mgp-website.settings', action: 'manage', description: 'Сайтын тохиргоо, лого, холбоо барих' },

    { resource: 'mgp-website.news', action: 'list', description: 'Мэдээ харах' },
    { resource: 'mgp-website.news', action: 'manage', description: 'Мэдээ бичих, нийтлэх' },

    { resource: 'mgp-website.messages', action: 'list', description: 'Холбоо барих хүсэлт харах' },
    { resource: 'mgp-website.messages', action: 'manage', description: 'Хүсэлтийг барьсан гэж тэмдэглэх' },

    { resource: 'mgp-website.catalog', action: 'list', description: 'Вэбэд гарах брэнд, ангилал харах' },
    { resource: 'mgp-website.catalog', action: 'manage', description: 'Брэнд, ангиллыг вэбэд нийтлэх' },

    /*
     * ! ЗУРАГ БАЙРШУУЛАХ НЬ ТУСДАА ЭРХ. Урьд нь `mgp-website.pages:manage`
     * ! шаарддаг байсан бөгөөд «бүх засварлагч тэр эрхтэй тул давхардал»
     * ! гэсэн тайлбартай байв. Тэр үндэслэл ЗӨВХӨН МЭДЭЭ засах дүр гартал
     * ! үнэн байсан: мэдээний админд хуудас засах эрх өгөхгүйгээр нүүр
     * ! зураг оруулах арга байхгүй болно.
     */
    { resource: 'mgp-website.media', action: 'upload', description: 'Вэбсайтын зураг байршуулах' },
  ],

  navigation: [
    {
      label: 'Веб сайт MPG',
      items: [
        {
          label: 'Хуудсууд',
          href: '/mgp-website/pages',
          icon: 'FileTextIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'mgp-website.pages:list',
        },
        {
          label: 'Сайтын меню',
          href: '/mgp-website/menu',
          icon: 'Menu',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'mgp-website.menu:manage',
        },
        {
          label: 'Мэдээ мэдээлэл',
          href: '/mgp-website/news',
          icon: 'NewspaperIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'mgp-website.news:list',
        },
        {
          label: 'Каталог',
          href: '/mgp-website/catalog',
          icon: 'TagIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'mgp-website.catalog:list',
        },

        /*
         * ! БАРАА НЬ КАТАЛОГИЙН ТАБ БИШ, ТУСДАА ЦЭС. Хуучин Laravel-д ч
         * ! тусдаа маршрут байв (`mgp-website.catalog.products.*`) — 798 бараа
         * ! нь шүүлтүүр, хуудаслалт, брэндээр харах горимтой бүтэн дэлгэц
         * ! шаарддаг бөгөөд брэнд, ангиллын хажууд таб болж багтахгүй.
         */
        {
          label: 'Бараа',
          href: '/mgp-website/products',
          icon: 'PackageIcon',
          iconClassName: 'text-orange-600 dark:text-orange-400',
          permission: 'mgp-website.catalog:list',
        },
        {
          label: 'Холбоо барих хүсэлт',
          href: '/mgp-website/messages',
          icon: 'InboxIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'mgp-website.messages:list',
        },
        {
          label: 'Сайтын тохиргоо',
          href: '/mgp-website/settings',
          icon: 'SettingsIcon',
          iconClassName: 'text-slate-600 dark:text-slate-400',
          permission: 'mgp-website.settings:manage',
        },
      ],
    },
  ],

  /*
   * Блокийн засварлагч нь хуудасны ДОТОР амьдардаг тул `sections` нь тусдаа
   * resource биш — `/mgp-website/pages/:id` дээр л засагдана.
   */
  resources: [
    {
      name: 'mgp-website.pages',
      label: 'Хуудсууд',
      list: '/mgp-website/pages',
      show: '/mgp-website/pages/:id',
      create: '/mgp-website/pages/create',
      edit: '/mgp-website/pages/:id',
      canDelete: true,
    },
    {
      name: 'mgp-website.news',
      label: 'Мэдээ',
      list: '/mgp-website/news',
      show: '/mgp-website/news/:id',
      create: '/mgp-website/news/create',
      edit: '/mgp-website/news/:id',
      canDelete: true,
    },
    { name: 'mgp-website.messages', label: 'Холбоо барих хүсэлт', list: '/mgp-website/messages' },
    { name: 'mgp-website.catalog', label: 'Каталог', list: '/mgp-website/catalog' },
    /*
     * ! `apiPath` ЗААВАЛ. Нэрээс гаргавал `mgp-website/products` болох ч бодит
     * ! эцсийн цэг нь каталогийн доор (`mgp-website/catalog/products`) — барааны
     * ! ДАРАХ ТОХИРГОО тэнд амьдардаг. Замыг бичихгүй бол data provider
     * ! байхгүй зам рүү очно.
     */
    {
      name: 'mgp-website.products',
      label: 'Бараа',
      apiPath: 'mgp-website/catalog/products',
      list: '/mgp-website/products',
    },
  ],
} as const satisfies ModuleManifest
